class KlaviyoBis extends HTMLElement {
  constructor() {
    super();
    this.initialize();
  }

  initialize() {
    this.trigger = this.querySelector('[data-open-bis]');
    if (this.trigger) {
      this.trigger.addEventListener('click', this.onOpenBisClick.bind(this));
    }


    this.modal = document.createElement('div');
    this.modal.className = 'klaviyo-bis-modal';
    this.modal.innerHTML = `
      <div class="klaviyo-bis-modal__overlay"></div>
      <div class="klaviyo-bis-modal__content">
        <button class="klaviyo-bis-modal__close" aria-label="Close">×</button>
        <h2>Get notified when back in stock</h2>
        <p>Register to receive a notification when this item is available.</p>
        <form class="klaviyo-bis-form">
          <div class="klaviyo-bis-form__field">
            <label for="klaviyo-bis-email">Email</label>
            <input type="email" id="klaviyo-bis-email" required>
          </div>
          <button type="submit" class="button">Notify me when available</button>
        </form>
        <div class="klaviyo-bis-form__success" hidden>
          You're in! We'll let you know when it's back.
        </div>
      </div>
    `;

    document.body.appendChild(this.modal);

    this.modal.querySelector('.klaviyo-bis-modal__overlay').addEventListener('click', () => this.closeModal());
    this.modal.querySelector('.klaviyo-bis-modal__close').addEventListener('click', () => this.closeModal());
    this.modal.querySelector('.klaviyo-bis-form').addEventListener('submit', (e) => this.handleSubmit(e));
  }

  openModal() {
    this.modal.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  closeModal() {
    this.modal.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  async onOpenBisClick(e) {
    e.preventDefault();
    this.openModal();
  }

  async handleSubmit(e) {
    e.preventDefault();
    const email = this.modal.querySelector('#klaviyo-bis-email').value;
    const variantId = document.querySelector('input[name="id"]').value;

    const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${this.dataset.klaviyoKey}`;

    const options = {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: this.dataset.bisRevision,
        'content-type': 'application/vnd.api+json'
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                }
              }
            },
            channels: ['EMAIL']
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variantId}`
              }
            }
          }
        }
      })
    };

    try {
      const response = await fetch(url, options);
      if (response.status !== 202) {
        throw new Error('Failed to subscribe');
      }
      
      // Show success message
      const form = this.modal.querySelector('.klaviyo-bis-form');
      const success = this.modal.querySelector('.klaviyo-bis-form__success');
      form.hidden = true;
      success.hidden = false;
      

      setTimeout(() => {
        this.closeModal();
    
        form.hidden = false;
        success.hidden = true;
        form.reset();
      }, 2000);
    } catch (error) {
      console.error('Error:', error);
      alert('Unable to process your request. Please try again.');
    }
  }
}

if (!customElements.get('klaviyo-bis')) {
  customElements.define('klaviyo-bis', KlaviyoBis);
}
